export function usernameWithoutSpaces(text: string) {
	return text.replace(/\s/g, '');
}
